import {
  Box,
  Button,
  Grid,
  Modal,
  Typography,
  Divider,
  Checkbox,
  TextField
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { isEmpty, showToast } from '../utils/AppHelper'
import { useTheme } from '@mui/styles'

import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import moment from 'moment'
import serverData from '../api/ServerData'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logoutUser } from '../actions/loginActions'
import AppButton from './AppButton'
import { ENV } from '../ENV'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 5,
  p: 2
}

export default function NestedModals ({ data }) {
  const theme = useTheme()

  const dispatch = useDispatch()
  const navigate = useNavigate()

  var { open, item, onClose } = data
  const [notify, setNotify] = useState('')
  const [reasonOpen, setReasonOpen] = useState(false)
  const [formError, setFormError] = useState({})

  const [other, setOther] = useState(false)
  const [otherText, setOtherText] = useState('')
  const [loading, setLoading] = useState(false)

  const [reasons, setReasons] = useState([
    {
      label: 'The job was filled internally.',
      isChecked: false
    },
    {
      label: 'The job was filled with the help of other sources.',
      isChecked: false
    },
    {
      label: `A non-${ENV.product_name} candidate is in consideration for the job offer.`,
      isChecked: false
    },
    {
      label:
        'This position is canceled and no longer available due to the change of the budget.',
      isChecked: false
    },
    {
      label: 'There is a company-wide or department-wide halt in hiring.',
      isChecked: false
    },
    {
      label: 'The company or the department is re-organizing.',
      isChecked: false
    },
    {
      label: 'The hiring manager for this job is unavailable.',
      isChecked: false
    },
    {
      label: 'The hiring manger for this job has changed.',
      isChecked: false
    },
    {
      label: `${ENV.product_name} was unable to supply candidates that meet the company's expectations.`,
      isChecked: false
    },
    {
      label: 'This job was cancelled.',
      isChecked: false
    }
  ])

  const handleNext = () => {
    const error = {}
    if (isEmpty(notify)) {
      error.notify =
        'Please select Yes if you would like to send a notification to the recruiters who have taken an interest in this job and the candidates who are under consideration or else select No.'
    } else {
      setReasonOpen(true)
    }

    setFormError(error)
  }

  const handlePrevious = () => {
    setReasonOpen(false)
    setNotify()
  }
  const handleClose = () => {
    setReasonOpen(false)
    setNotify()
    onClose()
  }

  const handleCloseJob = () => {
    const error = {}
    let filteredReasons = reasons.filter(e => e.isChecked)
    if (filteredReasons.length == 0 && !other) {
      showToast('Please select reasons')
    } else {
      if (other && isEmpty(otherText)) {
        error.other = 'Please provide a brief explanation for closing the job.'
        setFormError(error)
      } else {
        setLoading(true)
        var body = {
          jobId: item.jobId,
          closeReasons: reasons.filter(e => e.isChecked).map(e => e.label),
          closeReasonOther: otherText,
          isNotifyUsers: notify === 'yes'
        }
        serverData.closeJob(
          body,
          result => {
            if (result.status) {
              showToast(result.message, false)
              onClose(true)
            } else {
              showToast(result.message)
            }
            setLoading(false)
          },
          error => {
            setLoading(false)
            if (error.status == 401) {
              dispatch(logoutUser(navigate)) // eslint-disable-next-line
            }
          }
        )
      }
    }
  }
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography id='modal-modal-title'>
          <Grid
            container
            spacing={0}
            style={{ fontWeight: 300, fontSize: '14px' }}
          >
            <Grid item xs={6}>
              {item?.jobTypeName}
            </Grid>
            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                justifyContent: 'end',
                color: theme.palette.primary.main
              }}
            >
              {item?.companyname}
            </Grid>

            <Grid item xs={6} style={{ fontSize: '28px', fontWeight: 200 }}>
              {item?.jobTitle}
            </Grid>
            <Grid item xs={6}>
              <Grid
                container
                direction={'column'}
                spacing={0}
                style={{ display: 'flex', alignItems: 'flex-end' }}
              >
                <Grid item xs={6}>
                  {item?.city},{item?.state}, {item?.country}
                </Grid>
                <Grid item xs={6} style={{ fontStyle: 'italic' }}>
                  Posted on: {moment(item?.createdAt).fromNow()}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Typography>
        <Typography
          id='modal-modal-description'
          sx={{ mt: 2 }}
          style={{
            whiteSpace: 'pre-line',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          {!reasonOpen ? (
            <Grid
              container
              spacing={2}
              style={{
                border: `1px solid ${theme.palette.border.main}`,
                marginLeft: '1px',
                marginTop: '1px',
                borderRadius: '4px'
              }}
            >
              <Grid item xs={12} style={{ paddingRight: '16px' }}>
                <Grid container spacing={1} style={{ fontSize: '12px' }}>
                  <Grid
                    item
                    xs={5}
                    style={{
                      padding: '0px',
                      color: theme.palette.primary.main,
                      fontWeight: 500
                    }}
                  >
                    Step 1 - Notify the recruiters and the candidates
                  </Grid>
                  <Grid item xs={1}>
                    <ArrowForwardIosIcon />
                  </Grid>
                  <Grid item xs={6}>
                    Step 2 - Reason for closing the job (only {ENV.product_name}{' '}
                    can see it)
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} style={{ paddingLeft: '0px' }}>
                <Divider
                  style={{
                    width: '100%',
                    backgroundColor: theme.palette.border.main
                  }}
                />
              </Grid>
              <Grid item xs={12} style={{ paddingRight: '16px' }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} style={{ display: 'flex' }}>
                    Before we close this job, we have a quick question for you.
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: 'flex',
                      fontSize: '14px',
                      fontWeight: 300
                    }}
                  >
                    Would you like to send a notification to the recruiters who
                    have taken an interest in this job. The notification will
                    let them know that the job is closed.
                  </Grid>
                  <Grid item xs={12} style={{ display: 'flex' }}>
                    <FormControl>
                      <RadioGroup
                        row
                        name='row-radio-buttons-group'
                        onChange={e => setNotify(e.target.value)}
                      >
                        <FormControlLabel
                          value='yes'
                          control={<Radio />}
                          label='Yes'
                        />
                        <FormControlLabel
                          value='no'
                          control={<Radio />}
                          label='No'
                        />
                      </RadioGroup>
                      <FormHelperText>{formError.notify}</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={1}>
              <Grid
                container
                spacing={2}
                style={{
                  border: `1px solid ${theme.palette.border.main}`,
                  marginLeft: '1px',
                  marginTop: '1px',
                  borderRadius: '4px'
                }}
              >
                <Grid item xs={12} style={{ paddingRight: '16px' }}>
                  <Grid container spacing={1} style={{ fontSize: '12px' }}>
                    <Grid
                      item
                      xs={12}
                      style={{
                        padding: '0px',
                        color: theme.palette.primary.main,
                        fontWeight: 500
                      }}
                    >
                      Step 2 - Reason for closing the job (only{' '}
                      {ENV.product_name} can see it)
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} style={{ paddingLeft: '0px' }}>
                  <Divider
                    style={{
                      width: '100%',
                      backgroundColor: theme.palette.border.main
                    }}
                  />
                </Grid>
                <Grid
                  container
                  spacing={0}
                  style={{
                    paddingLeft: '16px',
                    maxHeight: '50vh',
                    overflowY: 'auto'
                  }}
                >
                  <FormControl>
                    {reasons.map((item, index) => (
                      <FormControlLabel
                        control={<Checkbox checked={item.isChecked} />}
                        label={item.label}
                        onClick={() => {
                          var data = [...reasons]
                          data[index].isChecked = !data[index].isChecked
                          setReasons(data)
                        }}
                      />
                    ))}

                    <FormControlLabel
                      fullWidth
                      control={<Checkbox />}
                      label='Others'
                      checked={other}
                      onChange={e => setOther(e.target.checked)}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              {other && (
                <Grid item xs={12} style={{ paddingLeft: '0px' }}>
                  <TextField
                    sx={{ input: { color: 'black' } }}
                    placeholder="Please explain in few words why you're closing this job."
                    required={other ? true : false}
                    fullWidth
                    size='small'
                    value={otherText}
                    onChange={e => {
                      var { value } = e.target
                      if (value.length < 100) {
                        setOtherText(e.target.value)
                      }
                    }}
                    error={formError.other}
                    helperText={formError.other}
                  />
                </Grid>
              )}
            </Grid>
          )}
        </Typography>
        {!reasonOpen ? (
          <Grid container spacing={2}>
            <Grid item>
              <Button
                variant='contained'
                fullWidth
                onClick={() => handleNext()}
                style={{ textTransform: 'capitalized', marginTop: 10 }}
              >
                Next
              </Button>
            </Grid>

            <Grid item>
              <Button
                variant='text'
                fullWidth
                onClick={onClose}
                style={{ textTransform: 'capitalized', marginTop: 10 }}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={2}>
            <Grid item>
              <Button
                variant='text'
                fullWidth
                onClick={handlePrevious}
                style={{ textTransform: 'none', marginTop: 10 }}
              >
                Previous
              </Button>
            </Grid>

            <Grid item>
              <AppButton
                onClick={() => handleCloseJob()}
                name={
                  notify === 'yes' ? (
                    <>Close job and notify users</>
                  ) : (
                    <>Close job without notification</>
                  )
                }
                style={{ marginTop: 10 }}
                loading={loading}
              />
            </Grid>

            <Grid item>
              <Button
                variant='text'
                fullWidth
                onClick={handleClose}
                style={{ textTransform: 'none', marginTop: 10 }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        )}
      </Box>
    </Modal>
  )
}
